import { render, staticRenderFns } from "./EvaluationTrainingColdMeasurePage.vue?vue&type=template&id=6d1ec496&"
import script from "./EvaluationTrainingColdMeasurePage.vue?vue&type=script&lang=js&"
export * from "./EvaluationTrainingColdMeasurePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports